import { css } from '@emotion/react';

/**
 * Shared sizing for the bundle's large content dialogs (AI message, Coursera
 * templates, edit-and-resend, message details, email preview). Caps the width
 * at the design's 864px: CDS `width="large"` scales with the viewport but has no
 * upper bound, so the cap keeps the dialog from growing wider than the design on
 * large screens while its responsive width still shrinks to fit narrow viewports
 * (a fixed width would overflow them). The height cap is 93vh (CDS defaults to
 * 80vh) so the dialog hugs its content without an internal scrollbar on shorter
 * viewports, while still capping growth so it never overflows the screen.
 *
 * The css prop composes after CDS's internal styles, so a same-specificity
 * override wins. Pair with `width="large"` on the Dialog.
 */
export const messagingDialogSize = css`
  .cds-Dialog-dialog {
    max-width: 864px;
    max-height: 93vh;
  }
`;
